import React, { Component } from "react";
import styles from './styles.css'
import logo from "./logo.png"
import Container from '../Container'

class Footer extends Component {
  render() {
    return (
      <Container align='center'>
        <div className="footer">
          <div className="footer__logo">
            <img width="100px" src={logo} />
          </div>
          <div className="footer__socials">
            <a href="https://github.com/mattpatterson94" target="_blank">Github</a>
            <a href="https://twitter.com/mattpatterson94" target="_blank">Twitter</a>
            <a href="https://linkedin.com/mattpatterson94" target="_blank">LinkedIn</a>
          </div>
        </div>
      </Container>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js